// Ported verbatim from the if/else chain in head.php, which keyed off
// basename($_SERVER['PHP_SELF']). Titles and descriptions are unchanged so the
// SERP snippets stay identical; only the canonical/og:url paths lose the .php.

export const SITE_URL = "https://chestsurgeryindia.com";

export type PageSeo = {
  title: string;
  description: string;
  /** Canonical path, e.g. "/about". Combined with SITE_URL. */
  canonical: string;
  image?: string;
  type?: "website" | "article";
  ogTitle?: string;
  ogDescription?: string;
};

export const pageSeo: Record<string, PageSeo> = {
  "/": {
    title:
      "Chest Surgery in India | Dr.Parveen Yadav - Chest Surgeon in Delhi & Gurgaon ",
    description:
      "Looking for the chest surgery In India? Book your appointment now with  Dr Parveen Yadav - The top thoracic chest surgeon In Delhi & Gurgaon for treatment.",
    canonical: "/",
    ogTitle:
      "Chest Surgery in India | Dr.Parveen Yadav - Chest Surgeon in Delhi & Gurgaon",
  },
  "/about": {
    title: "Surgical Oncologist In Gurgaon - About us",
    description:
      "Dr. Parveen Yadav: Expert in Minimal Invasive Thoracic & Robotic Surgeries, Surgical Oncology. Poster Award, Indian Cancer Congress 2011.",
    canonical: "/about",
  },
  "/esophageal-cancer-treatment-gurgaon": {
    title:
      "Esophageal Cancer  Treatment In Gurgaon | Food Pipe cancer Surgery",
    description:
      "Book an appointment for esophageal cancer treatment (food-pipe cancer) in Delhi & Gurgaon, India. Consult top cancer surgeon today!",
    canonical: "/esophageal-cancer-treatment-gurgaon",
  },
  "/lungs-cancer-treatment-gurgaon": {
    title: "Lung Cancer Treatment & Surgery In Gurgaon, Delhi |Dr. Parveen Yadav",
    description:
      "Schedule an appointment for Lung Cancer Treatment In Delhi & Gurgaon, India. Consult with Dr. Parveen Yadav the top surgeon for lung cancer surgery.",
    canonical: "/lungs-cancer-treatment-gurgaon",
  },
  "/tracheal-cancer-treatment-gurgaon": {
    title: "Tracheal cancer treatment in Gurgaon | Dr. Parveen Yadav",
    description:
      "Get Proper Tracheal cancer treatment in Delhi & Gurgaon, India from the Top Surgeon. Consult with Dr. Parveen Yadav the top surgeon for Thorat cancer surgeries.",
    canonical: "/tracheal-cancer-treatment-gurgaon",
  },
  "/chest-wall-tumor-surgery-gurgaon": {
    title: "Chest Wall Tumor Treatment In Gurgaon & Delhi | Dr. Parveen Yadav",
    description:
      "Dr. Parveen Yadav the Surgical Oncologist for Chest Wall Tumor Treatment In Gurgaon,India. Get in touch with Chest Surgery India to make an appointment.",
    canonical: "/chest-wall-tumor-surgery-gurgaon",
  },
  "/mediastinal-tumor-treatment-gurgaon": {
    title: "Mediastinal Tumor treatment in Gurgaon & Delhi | Dr. Parveen Yadav",
    description:
      "Dr. Parveen Yadav is the Oncologist Surgeon for Mediastinal Tumor Treatment in Gurgaon, India. Get in touch with Chest Surgery India to make an appointment",
    canonical: "/mediastinal-tumor-treatment-gurgaon",
  },
  "/empyema-treatment-gurgaon": {
    title: "Empyema Treatment In Gurgaon | Surgical treatment | Dr. Parveen Yadav",
    description:
      "Book your consultation for Empyema Treatment In Gurgaon, India, with Dr.Parveen Yadav the Empyema surgeon in Gurgaon, India.",
    canonical: "/empyema-treatment-gurgaon",
  },
  "/bronchopleural-fistula-treatment-gurgaon": {
    title: "Bronchopleural Fistula Treatment In Gurgaon | Dr. Parveen Yadav",
    description:
      "Schedule an appointment for Bronchopleural Fistula Treatment In Delhi & Gurgaon, India, thoracic Oncologist Surgeon Dr. Parveen Yadav.",
    canonical: "/bronchopleural-fistula-treatment-gurgaon",
  },
  "/bullous-disease": {
    title: "Bullous disease Treatment In Gurgaon | Dr. Parveen Yadav",
    description:
      "Book an appointment for bullous disease (skin disease) treatment in Delhi & Gurgaon, India. Consult Dr. Parveen Yadav today!",
    canonical: "/bullous-disease",
  },
  "/upper-thorax-conditions-surgery-india": {
    title: "Expert Upper Thorax Surgery & Treatment in India | Chest Surgery India",
    description:
      "Get advanced care for upper thorax conditions at Chest Surgery India. Led by Dr. Parveen Yadav, we offer robotic and minimally invasive treatments for lung, esophageal, and chest disorders. Book your consultation today!",
    canonical: "/upper-thorax-conditions-surgery-india",
  },
  "/second-opinion-thoracic-surgeon-india": {
    title: "Free Second Opinion by Leading Thoracic Surgeon – Dr. Parveen Yadav",
    description:
      "Get a free second opinion from Dr. Parveen Yadav, top thoracic surgeon in India. Quick, expert advice for lung and chest conditions within 48 hours.",
    canonical: "/second-opinion-thoracic-surgeon-india",
  },
  "/stage0-lung-cancer-treatment": {
    title: "Stage 0 Lung Cancer Treatment in India - Expert Care by Dr. Parveen Yadav",
    description:
      "Discover effective Stage 0 lung cancer treatments at India's leading hospital, led by Dr. Parveen Yadav. Contact us for advanced care and personalized treatment plans.",
    canonical: "/stage0-lung-cancer-treatment",
  },
  "/stage1-lung-cancer-treatment": {
    title: "Stage 1 Lung Cancer Treatment in India - Expert Oncological Care",
    description:
      "Receive Stage 1 lung cancer treatment in India under the guidance of Dr. Parveen Yadav. Advanced techniques and compassionate care for your recovery.",
    canonical: "/stage1-lung-cancer-treatment",
  },
  "/stage2-lung-cancer-treatment": {
    title: "Stage 2 Lung Cancer Treatment - Leading Hospital in India",
    description:
      "Trust Dr. Parveen Yadav for advanced Stage 2 lung cancer treatment at India's premier lung cancer hospital. Start your journey to recovery today.",
    canonical: "/stage2-lung-cancer-treatment",
  },
  "/stage3-lung-cancer-treatment": {
    title: "Stage 3 Lung Cancer Treatment by Experts in India",
    description:
      "Specialized Stage 3 lung cancer treatment at India's top hospital, led by Dr. Parveen Yadav. Benefit from innovative therapies and expert care. Contact us today.",
    canonical: "/stage3-lung-cancer-treatment",
  },
  "/stage4-lung-cancer-treatment": {
    title: "Stage 4 Lung Cancer Treatment in India - Advanced Care",
    description:
      "Advanced Stage 4 lung cancer treatment in India at the hospital under Dr. Parveen Yadav's expertise. Comprehensive care for complex cases. Book a consultation now.",
    canonical: "/stage4-lung-cancer-treatment",
  },
  "/video": {
    title: "Cancer Treatment in Gurgaon - Dr. Parveen Yadav- Chest Surgery India",
    description:
      "Explore advanced chest surgery procedures in India through informative videos showcasing expertise and patient care.",
    canonical: "/video",
  },
  "/gallery": {
    title:
      "Top-notch Chest Surgery Gallery in India | Expert Surgeons, Advanced Procedures",
    description:
      "Discover transformative chest surgeries at Chest Surgery India's gallery. See before-and-after images showcasing expert procedures and exceptional results. ",
    canonical: "/gallery",
  },
  "/contact": {
    title: "Contact Details -Chest Surgery India",
    description:
      "Contact Chest Surgery India for top-notch diagnosis & treatment of various chest conditions including cancer, tumors, and respiratory diseases.",
    canonical: "/contact",
  },
  // head.php had no branch for thank-you.php, so it rendered with empty
  // title/description. Given a real title here; it is noindex either way.
  "/thank-you": {
    title: "Thank You | Chest Surgery India",
    description:
      "Thank you for contacting Chest Surgery India. Our team will get back to you shortly.",
    canonical: "/thank-you",
  },
  "/blog": {
    title: "Blog | Chest Surgery India - Dr. Parveen Yadav",
    description:
      "Articles on lung cancer, esophageal cancer, thoracic surgery and chest conditions from Dr. Parveen Yadav and the Chest Surgery India team.",
    canonical: "/blog",
  },
};

export function seoFor(route: string): PageSeo {
  return (
    pageSeo[route] ?? {
      title: "Chest Surgery India | Dr. Parveen Yadav",
      description:
        "Chest Surgery India - Dr. Parveen Yadav, thoracic and surgical oncologist in Delhi & Gurgaon.",
      canonical: route,
    }
  );
}
